import React from 'react';
import { format } from 'date-fns';
import { HiOutlineDocumentText, HiOutlineCheckCircle, HiOutlineExclamation } from 'react-icons/hi';
import './ReportList.scss';

const ReportList = ({ reports, onSelectReport, selectedReportId }) => {
  // Function to format dates for display
  const formatDate = (date) => {
    if (!date) return 'N/A';
    
    // Handle Firebase timestamp
    if (date && date.seconds) {
      return format(new Date(date.seconds * 1000), 'MMM dd, yyyy');
    }
    
    // Handle regular Date object
    return format(new Date(date), 'MMM dd, yyyy');
  };

  // Function to determine the report status based on properties
  const getReportStatus = (report) => {
    if (report.reviewedAt) {
      return 'reviewed';
    } else if (report.submittedAt) {
      return 'pending';
    } else {
      return 'blank';
    }
  };

  // Function to get status icon and class
  const getStatusDetails = (report) => {
    const status = getReportStatus(report);
    
    switch (status) {
      case 'reviewed':
        return {
          icon: <HiOutlineCheckCircle className="icon reviewed" />,
          label: 'Reviewed',
          class: 'reviewed'
        };
      case 'pending':
        return {
          icon: <HiOutlineExclamation className="icon pending" />,
          label: 'Pending Review',
          class: 'pending'
        };
      case 'blank':
        return {
          icon: <HiOutlineDocumentText className="icon blank" />,
          label: 'Not Started',
          class: 'blank'
        };
      default:
        return {
          icon: <HiOutlineDocumentText className="icon" />,
          label: 'Unknown',
          class: ''
        };
    }
  };

  return (
    <div className="report-list">
      <h3 className="list-title">Weekly Reports</h3>
      
      {reports.length === 0 ? (
        <div className="empty-state">
          <p>No reports found for this employee</p>
        </div>
      ) : (
        <div className="reports">
          {reports.map(report => {
            const statusDetails = getStatusDetails(report);
            const status = getReportStatus(report);
            
            return (
              <div 
                key={report.id} 
                className={`report-item ${selectedReportId === report.id ? 'selected' : ''}`}
                onClick={() => onSelectReport(report)}
              >
                {statusDetails.icon}
                
                <div className="report-details">
                  <div className="date-range">
                    {formatDate(report.weekStartDate)} - {formatDate(report.weekEndDate)}
                  </div>
                  
                  <div className={`status ${statusDetails.class}`}>
                    {statusDetails.label}
                  </div>
                  
                  <div className="meta-info">
                    {status === 'blank' ? (
                      <span>Created: {formatDate(report.createdAt || report.weekStartDate)}</span>
                    ) : (
                      <span>Submitted: {formatDate(report.submittedAt)}</span>
                    )}
                    
                    {status === 'reviewed' && (
                      <span>Reviewed: {formatDate(report.reviewedAt)}</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ReportList; 